"use client";

import styles from './_addressing.module.scss';
import CustomImage from '@/components/image';

export default function HcpCahOverviewAddressing() {
  return (
    <section className={styles.address}>
      <div className={`container`}>
        <div className={styles.address_heading}>Addressing excess androgens often requires high GC doses, but these doses can lead to many short- and long-term comorbidities.<sup>1,2</sup></div>
        <div className={styles.address_data}>
          <div className={`${styles.address_data_group} ${styles.address_data_group__symptoms}`}>
            <div className={styles.address_data_heading}>Symptoms of excess ACTH and adrenal <span className='no-wrap'>androgens<sup>1,2,7,9-12</sup>:</span></div>
            <div className={styles.address_data_list_cols}>
              <ul className={styles.address_data_list}>
                <li>Early puberty</li>
                <li>Growth issues*</li>
                <li>Fertility problems</li>
                <li>TARTs/OARTs</li>
                <li>Acne</li>
              </ul>
              <ul className={styles.address_data_list}>
                <li>Hirsutism</li>
                <li>Hypertension*</li>
                <li>Hyperlipidemia*</li>
                <li>Obesity*</li>
                <li>Anxiety and <br className="hidden tablet-small:inline-block" />depression*</li>
              </ul>
            </div>
            <CustomImage
              src='/images/components/CAH-Overview_Balance-Icon.svg'
              width={170}
              height={170}
              alt='' />
          </div>
          <div className={`${styles.address_data_group} ${styles.address_data_group__comorbid}`}>
            <div className={styles.address_data_heading}>Comorbidities related to high GC doses<sup>1,2</sup>:</div>
            <div className={styles.address_data_list_cols}>
              <ul className={styles.address_data_list}>
                <li>Obesity*</li>
                <li>Growth issues*</li>
                <li>Hypertension*</li>
                <li>Insulin resistance</li>
                <li>Hyperlipidemia*</li>
              </ul>
              <ul className={styles.address_data_list}>
                <li>Osteopenia and <br className="hidden tablet-small:inline-block" />osteoporosis</li>
                <li>Cognitive impairment</li>
                <li>Mood disorders</li>
                <li>Anxiety and depression*</li>
                <li>Sleep disturbances</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.address_callouts}>
          <div className={`${styles.address_callout} ${styles.address_callout__gradient}`}>
            <p>Symptoms of androgen excess and high-dose GC comorbidities can affect patients&apos; quality of life.</p>
          </div>
          <ul className={`${styles.address_callout_footnote} text-black`}>
            <li><span className={styles.address_callout_footnote_symbol}>*</span>These impacts could be related to excess androgen, high GC doses, or both.<sup>7</sup></li>
          </ul>
          <div className={`${styles.address_callout} ${styles.address_callout__gradient}`}>
            <p>A modified Delphi panel reached 100% consensus that a ≥2.5&nbsp;mg/day (≥~1.4&nbsp;mg/m<sup>2</sup>/day) reduction in GC dose is clinically meaningful, and <strong>70%&nbsp;agreed that any reduction is clinically meaningful.</strong><sup className="!font-bold">13&dagger;&Dagger;</sup></p>
          </div>
          <ul className={`${styles.address_callout_footnote} text-black`}>
            <li><span className={styles.address_callout_footnote_symbol}><sup>&dagger;</sup></span>The 100% consensus reflects 10 of 10 endocrinologists surveyed.<sup>13</sup></li>
            <li><span className={styles.address_callout_footnote_symbol}><sup>&Dagger;</sup></span>The 70% figure reflects 7 of 10 endocrinologists surveyed.<sup>13</sup></li>
          </ul>
        </div>
      </div>
    </section>
  );
}